(function ($) {
    $(document).ready(function () {
        if ($('body').hasClass('theme-new')) {
            $(document).on('click', '.wrapper-qty', function(e) {
                const $input = $(this).find('.product-qty');

                if ($input.prop('disabled') || $input.prop('readonly')) {
                    return;
                }

                const min = parseFloat($input.attr('min')) || 1;
                const max = parseFloat($input.attr('max')) || Infinity;

                const rect = this.getBoundingClientRect();
                const x = e.clientX - rect.left;


                const paddingLeft = parseFloat($(this).css('padding-left'));
                if ((x - paddingLeft) < 0) {
                    let current = Math.floor(parseFloat($input.val())) || min;
                    if (current > min) {
                        $input.focus().val(current - 1).trigger('change').blur();
                    }
                }

                else if ((x + paddingLeft) > rect.width - 5) {
                    let current = Math.floor(parseFloat($input.val())) || min;
                    if (current < max) {
                        $input.focus().val(current + 1).trigger('change').blur();
                    }
                }
            });
        }
    });
})(jQuery);